// Sugalarm — cycle 468: the KIOSK's lockout. A full-stage surface with the
// operator's sentence and nothing else: no control, no link, no QR code (the
// kiosk never sells), no audio. Painted over the whole 1024×640 design box
// (absolute, inset 0, inside the `.kiosk` stage's own stacking context) so
// the header, the nav and the stale last screen are all covered. z-index 300:
// above the nav (40) and the chrome, below the alarm layer (370) — though a
// lock never lands while an alarm is live, and a locked member raises none.
//
// Operator-authorized exceptions (cycle 468): this is a place where the No
// Data banner does not show (`useAlarmSounds` stands the No Data alarm down
// for a locked member), and carrying no audio and no alarm it is outside
// the alarm-control rules.

import { LAPSED_SENTENCE } from "../../lib/serviceLock";
import styles from "./KioskLockout.module.css";

export function KioskLockout() {
  return (
    <div className={styles.root} data-testid="kiosk-lockout" role="status" aria-live="polite">
      <div className={styles.inner}>
        <div className={styles.title}>Monitoring has stopped</div>
        <p className={styles.sentence} data-testid="lockout-sentence">
          {LAPSED_SENTENCE}
        </p>
      </div>
    </div>
  );
}
